import { Injectable } from '@angular/core';
import { Observable, timeout } from 'rxjs';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  private readonly SERVER_API_URL: any;

  constructor(private localStorage: LocalStorageService, private sessionStorage: SessionStorageService) {
    this.SERVER_API_URL = environment.SERVER_API_URL;
  }
  defaultTimeout = 180 * 1000;
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutValue = request.headers.get('timeout') || this.defaultTimeout;
    const timeoutValueNumeric = Number(timeoutValue);
    if (request.body) {
      request.body.requestId  = Date.now();
    }
    const params: any = request.params;
    params.map = params.map || new Map();
    if (params.map) {
      params.map.set('requestId', [Date.now()]);
    }
    const token = this.sessionStorage.retrieve('token');
    const object: any = {
      setHeaders: {
        'accept-language': 'vi',
      },
      withCredentials: true
    };
    if (token) {
      object.setHeaders['x-auth-token'] = token;
    }
    request = request.clone(object);
    return next.handle(request).pipe(
      timeout(timeoutValueNumeric),
    );
  }
}
